/**Reference for regular expression: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email */
const emailAddressRegex = /^[a-z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i;

export default function isValidEmailAddress(emailAddress: string): boolean {
    return emailAddressRegex.test(emailAddress);
}
